import React from 'react';
import { Suspense } from 'react';
import { Navigate, Route, Routes, useParams, useLocation } from 'react-router-dom';

import { StepsLoading } from 'pages/public/Loading';
import NotFoundPage from 'pages/public/NotFoundPage';

import BDOTransferRequest from '../transfer-requests/BDOTransferRequest';
import BDOPointsRedemptions from './BDOPointsRedemptions';

const PointsRedemptions = () => {
  const params = useParams();
  const location = useLocation();

  return (
    <Suspense fallback={<StepsLoading />}>
      <Routes>
        <Route path="" element={<Navigate to={`${location.pathname}/list`} replace />} />
        <Route path="list/*" element={<BDOPointsRedemptions />} />
        <Route path="show/:id" element={<BDOTransferRequest />} />
        <Route element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default PointsRedemptions;
